/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';

import InfoLabel from 'components/common/InfoLabel/InfoLabel';
import { getLatestAssessmentEventById, deleteAssessmentEvent as deleteAssessmentEventMut } from 'graphql/operations';
import { NO_CACHE } from 'graphql/fetchPolicies';
import { EventTypes } from 'utils/constants';

export const FieldUpdates = props => {
  const { apolloClient, question, assessmentEvent } = props;
  const [showMessage, setShowMessage] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({ showUser: false, withLoader: false, message: 'assessment.simultaneousEdit.isTyping' });

  // handles new events
  useEffect(() => {
    let cleanUpFunc;
    if (assessmentEvent) {
      if (assessmentEvent.eventType === EventTypes.VALUE_CHANGE) {
        setShowMessage(true);
        setUpdateInfo({
          user: assessmentEvent.user,
          message: 'assessment.simultaneousEdit.otherUserAnswered',
          withLoader: false
        });

        const timeoutId = setTimeout(() => {
          setShowMessage(false);
        }, 5000);

        cleanUpFunc = () => {
          clearTimeout(timeoutId);
        };
      }

      if (assessmentEvent.eventType === EventTypes.TEXT_FIELD_TYPING) {
        const showUserIsTyping = assessmentEvent.action === 'START_TYPING';
        if (showUserIsTyping) {
          setShowMessage(true);
          setUpdateInfo({
            user: assessmentEvent.user,
            message: 'assessment.simultaneousEdit.isTyping',
            withLoader: true
          });
        } else if (showMessage) {
          if (updateInfo.message === 'assessment.simultaneousEdit.isTyping') {
            // When STOP_TYPING arrives, only remove message if current message is "Is typing..."
            setShowMessage(false);
          } else {
            // currently displaying `otherUserAnswered` message. Hide after 5 sec.
            const timeoutId = setTimeout(() => {
              setShowMessage(false);
            }, 5000);

            cleanUpFunc = () => {
              clearTimeout(timeoutId);
            };
          }
        }
      }

      apolloClient.mutate({
        mutation: deleteAssessmentEventMut,
        variables: { fieldId: question.id, eventType: assessmentEvent.eventType }
      });
    }
    return cleanUpFunc;
  }, [apolloClient, assessmentEvent, question.id]);

  return <InfoLabel show={showMessage} loader={updateInfo.withLoader} messageKey={updateInfo.message} user={updateInfo.user} />;
};

FieldUpdates.propTypes = {
  // TODO: Fix this...
  /* eslint-disable react/forbid-prop-types */
  apolloClient: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired
  /* eslint-enable react/forbid-prop-types */
};

const enhancer = compose(
  withApollo,
  graphql(getLatestAssessmentEventById, {
    options: props => ({
      variables: {
        fieldId: props.question.id
      },
      fetchPolicy: NO_CACHE
    }),
    name: 'getLatestAssessmentEventById'
  }),
  mapProps(props => ({
    apolloClient: props.client,
    question: props.question,
    assessmentEvent: props.getLatestAssessmentEventById.getLatestAssessmentEventById
  }))
);

const EnhancedComponent = enhancer(FieldUpdates);

export function FieldUpdatesHOC(WrappedComponent) {
  return props => {
    const { question } = props;
    return (
      <>
        <WrappedComponent {...props} />
        <EnhancedComponent question={question} />
      </>
    );
  };
}

export default FieldUpdatesHOC;
